import jQueryProvider from 'jquery';

const jQuery = jQueryProvider || window.jQuery || window.$;

if (!jQuery || typeof jQuery !== 'function') {
  throw new Error('jQuery global was not initialized');
}
// Prevent auto-execution of scripts when no explicit dataType was provided.
// prevents vulnerability CVE-2015-9251
jQuery.ajaxPrefilter(function (s) {
  if (s.crossDomain) {
    s.contents.script = false;
  }
});
// ensures compatibility with old libraries that
// uses non-browser supported self closing tags.
jQuery.htmlPrefilter = function (html) {
  return (
    html
      .replace(/<i([^>]*)\/>/gi, '<i$1></i>')
      .replace(/<em([^>]*)\/>/gi, '<em$1></em>')
      .replace(/<button([^>]*)\/>/gi, '<button$1></button>')
      .replace(/<label([^>]*)\/>/gi, '<label$1></label>')
      .replace(/<span([^>]*)\/>/gi, '<span$1></span>')
      .replace(/<a([^>]*)\/>/gi, '<a$1></a>')
      // this one is needed because of fullcalendar lib
      // remove and test full site when fullcalendar is
      // removed to prevent XSS vulnerability
      .replace(/<div([^>]*)\/>/gi, '<div$1></div>')
  );
};

window.$ = jQuery;
window.jQuery = jQuery;
export default jQuery;
